/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { EdgeAbstract } from 'cio/app-models/action-abstracts/multi-split';
import Component from '@glimmer/component';
interface MultiSplitEditorSortableListArgs {
  items: EdgeAbstract[];
  onDropAction: (item: EdgeAbstract, index: number) => unknown;
  groupName: string;
}

const PLACEHOLDER_OFFSETS = {
  width: 0,
  height: 0,
  top: 4,
  left: -10,
};

export default class MultiSplitEditorSortableList extends Component<MultiSplitEditorSortableListArgs> {
  get pluginOptions() {
    return {
      sortableListPlaceholder: {
        classes: ['sidebar-multi-split-group-sortable-placeholder', 'z-[5]'],
        offsets: PLACEHOLDER_OFFSETS,
        changeOffsetSignDependingOnPosition: true,
      },
    };
  }
}
